export default "__VITE_ASSET___w9_RogH__"